export default {
	TOGGLE_DEVICE: (state, device) => {
		state.device = device
	},

	SET_LANGUAGE: (state, language) => {
		state.language = language
		localStorage.language = language
	},

	SET_TOKEN: (state, token) => {
		state.token = token
		localStorage.token = token
	},

	SET_CONFIRMED: (state, confirmed) => {
		state.confirmed = Boolean(confirmed)
		localStorage.confirmed = Boolean(confirmed)
	},

	SET_CONFIRMED_CODE_LENGTH: (state, length) => {
		state.confirmedCodeLength = length
		localStorage.confirmedCodeLength = length
	},

	REMOVE_TOKEN: (state) => {
		state.token = null
		localStorage.token = ''
	},

	SET_USER: (state, user) => {
		state.user = user
	},

	SET_DEFAULT_CITY: (state, city) => {
		state.defaultCity = city
		localStorage.city = JSON.stringify(city)
	},

	SET_CITIES: (state, cities) => {
		state.cities = cities
	}
}
